const templateMarker = '{0}';

/**
 * It returns true if the value contains the template marker.
 * @param value - The value to check.
 */
const hasTemplate = (value?: string) => value?.includes(templateMarker);

/**
 * It returns true if the value starts with the first part of the template
 * or ends with the second part of the template
 * @param value - The value to check
 * @param template - The template to match against.
 * @returns A function that takes two arguments, value and template.
 */
const matchesTemplate = (value: string | undefined, template: string) => {
  if (!value) {
    throw Error('value is undefined');
  }

  if (!template) {
    throw Error('template is undefined');
  }

  if (value === template) {
    return true;
  }

  const parts = template.split(templateMarker);

  return value.startsWith(parts[0]) && value.endsWith(parts[1]);
};

/**
 * It replaces the template marker with the value
 * @param value - The value to be inserted into the template.
 * @param template - The template to fill.
 */
const fillTemplate = (value: string | undefined, template: string) => {
  if (!template) {
    throw Error('template is undefined');
  }

  if (value) {
    return template.replace(templateMarker, value);
  }

  return template;
};

export { hasTemplate, matchesTemplate, fillTemplate, templateMarker };
